import React from 'react';
import AddItem, { Props } from '@wix/da-ds/pkg/AddItem';

import s from './AddItemCard.scss';

export const AddItemCard: React.FC<Props> = props => (
  <AddItem className={s['add-item-card']} {...props} />
);

AddItemCard.displayName = 'AddItemCard';
export default AddItemCard;
